import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import moment from 'moment'
import UpdatePage from '../../../composents/UpdatePage'

const title = 'Top up'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'top up',
  breadcrumbs: [
    {
      title: 'Top Up',
      link: '/clients/top_up',
    },
  ],
}

export default function TopUpWaterCard() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [data, setData] = useState({}),
    [cost, setCost] = useState(0),
    [qty, setQty] = useState(0),
    [amount, setAmount] = useState(0),
    [consumer, setConsumer] = useState(),
    [subcription, setSubcription] = useState(),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true),
    [subscriptions, setSubcriptions] = useState([]),
    [step, setStep] = useState(1),
    cardOptions = [
      {
        value: 'cash',
        label: 'Cash',
      },
      {
        value: 'card',
        label: 'Card',
      },
      {
        value: 'wallet',
        label: 'Wallet',
      },
    ],
    [option, setOption] = useState({
      value: 'cash',
      label: 'Cash',
    })

  async function onGet() {
    setLoading(true)
    const response = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (response.status === 200) {
      setData(
        response.data.docs.map((e) => ({
          value: e.id,
          label: e.surname,
          client: e.client.id,
          balance: e.balance,
          wallet: e.wallet,
        }))
      )
    } else if (response.status === 403) {
      setFail(true)
    }

    let cit = await resources.subscription
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })

    if (cit.status === 200) {
      let a = []
      cit.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.title,
          client: el.client?.id,
          quantity: el.HDP,
          type: el.type,
          costLitre: el.HDPCOST,
          durationCycle: el.durationCycle,
        })
      })
      setSubcriptions(a)
    } else if (cit.status === 403) {
      setFail(true)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = Object.fromEntries(formData)
    object.card = data.id
    object.consumer = consumer.value
    if (subcription) object.subscription = subcription.value
    object.datas = {
      type: object.type,
      quantity: qty,
      received_amount: object.received_amount ?? 0,
      returned_amount: object.returned_amount ?? 0,
      receipt_number: object.receipt_number ?? '',
    }
    setLoader(true)
    setErrors({})
    let res = await resources.topUp
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/clients/top_up')
    } else if (res.status === 422) {
      const errors = res.data.errors.reduce((acc, error) => {
        return { ...acc, [error.field]: error.message }
      }, {})
      setErrors(errors)
      if ('consumer' in errors || 'subscription' in errors || 'quantity' in errors) {
        setStep(1)
      }
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterSubscription = () => {
    let all_cities = []
    if (consumer) {
      all_cities = subscriptions.filter((e) => e.client === consumer.client)
    }
    return all_cities
  }

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
      message="this page require clients,cards,subscriptions and consumers authorization"
    >
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                {step === 1 && (
                  <>
                    <div className="form-group mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Consumer
                      </label>
                      <Select
                        onChange={(e) => {
                          setConsumer(e)
                          setCost(0)
                          setQty(0)
                          setSubcription(null)
                        }}
                        options={data}
                        value={consumer}
                        isSearchable
                        isClearable
                        className={errors['consumer'] ? ' is-invalid' : ''}
                      />
                      {errors['consumer'] && (
                        <div className="invalid-feedback">{errors['consumer']}</div>
                      )}
                    </div>

                    <div className="form-group mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Subscription
                      </label>
                      <Select
                        onChange={(e) => {
                          setSubcription(e)
                          if (e) {
                            setCost(e?.costLitre * e?.quantity)
                            setQty(e?.quantity)
                          } else {
                            setCost(0)
                            setQty(0)
                          }
                        }}
                        options={filterSubscription()}
                        isSearchable
                        isClearable
                        value={subcription}
                        className={errors['subscription'] ? ' is-invalid' : ''}
                      />
                      {errors['subscription'] && (
                        <div className="invalid-feedback">{errors['subscription']}</div>
                      )}
                    </div>

                    <Field
                      className="mb-3"
                      type="number"
                      value={qty}
                      error={errors['quantity']}
                      readOnly={subcription?.type === 'fixed'}
                      onChange={(e) => {
                        if (subcription) {
                          if (e.target.value.length > 0) {
                            setCost(subcription.costLitre * parseInt(e.target.value))
                          } else {
                            setCost(0)
                          }
                        }

                        setQty(parseInt(e.target.value))
                      }}
                    >
                      Subscribed HDP quantity
                    </Field>

                    <Field className="mb-3" value={cost ?? 0} readOnly>
                      Subscription HDP cost
                    </Field>

                    <Field
                      className="mb-3"
                      value={moment()
                        .add(subcription?.durationCycle ?? 0, 'days')
                        .format('DD-MM-YYYY')}
                      readOnly
                    >
                      Subscription validity
                    </Field>

                    <Field className="mb-3" type="number" value={consumer?.balance + qty} readOnly>
                      Total Balance
                    </Field>
                  </>
                )}
                {step === 2 && (
                  <>
                    <div className="mb-3">
                      <label htmlFor="exampleInputEmail1" className="form-label">
                        Payment option
                      </label>
                      <Select
                        name="type"
                        onChange={(e) => {
                          setOption(e)
                          setAmount(0)
                        }}
                        options={cardOptions}
                        value={option}
                        isSearchable
                        isClearable={false}
                        className={errors['type'] ? ' is-invalid' : ''}
                      />
                      {errors['type'] && <div className="invalid-feedback">{errors['type']}</div>}
                    </div>

                    {option.value === 'card' && (
                      <Field name="receipt_number" className="mb-3" required>
                        Receipt number
                      </Field>
                    )}

                    {option.value === 'cash' && (
                      <>
                        <Field
                          type="number"
                          name="received_amount"
                          className="mb-3"
                          required
                          value={amount}
                          onChange={(e) => setAmount(parseInt(e.target.value))}
                        >
                          Received amount
                        </Field>

                        <Field
                          name="returned_amount"
                          className="mb-3"
                          readOnly
                          value={amount - cost}
                        >
                          Returned amount
                        </Field>
                      </>
                    )}

                    {option.value === 'wallet' && (
                      <Field readOnly value={consumer.wallet}>
                        Balance
                      </Field>
                    )}
                  </>
                )}

                {step === 1 && (
                  <div className="row ">
                    <div className="col-lg-12">
                      <div className="d-grid gap-2">
                        <Btn
                          class="btn waves-effect waves-light btn-primary"
                          type="button"
                          onClick={(e) => setStep(2)}
                        >
                          <i className="feather icon-arrow-right"></i> Next
                        </Btn>
                      </div>
                    </div>
                  </div>
                )}

                {step === 2 && (
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="d-grid gap-2">
                        <Btn
                          class="btn waves-effect waves-light btn-primary"
                          type="button"
                          onClick={(e) => setStep(1)}
                        >
                          <i className="feather icon-arrow-left"></i> Previous
                        </Btn>
                      </div>
                    </div>

                    {(option.value !== 'cash' || amount - cost >= 0) && (
                      <div className="col-lg-6">
                        <div className="d-grid gap-2">
                          <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                            <i className="feather icon-save"></i> recharger
                          </Btn>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
